import React from 'react';
import { useSetResolved } from '@wearejh/m2-pwa-engine/lib/router/useSetResolved';

import { Breadcrumb } from 'src/components/Breadcrumbs/breadcrumb.utils';
import { PostsByArrayOfIDs } from 'src/wordpress/components/PostsByArrayOfIDs';
import { RichText } from 'src/components/RichText/RichText';

import { CategoryItem, CategoryList } from '../CategoryList/CategoryList';
import { Container, Wrapper } from '../Layout';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';

type CategoryLandingPageProps = {
    blogPostIds?: string[];
    breadcrumbs: Breadcrumb[];
    categories: CategoryItem[];
    categoryShortDescription: string | null;
    description: string | null;
    name: string;
    pathname: string;
};

export function CategoryLandingPage(props: CategoryLandingPageProps) {
    useSetResolved();
    const { name, description, categories } = props;

    if (props.categoryShortDescription) {
        return (
            <Wrapper element="section" variant="page-inner" data-test-id="category-landing-page">
                <RichText content={props.categoryShortDescription} />
            </Wrapper>
        );
    }

    return (
        <Wrapper element="section" variant="page-inner-with-breadcrumb" data-test-id="category-landing-page">
            <Container>
                <Breadcrumbs breadcrumbs={props.breadcrumbs} current={props.name} />
                {categories && name && <CategoryList title={name} categories={categories} description={description} />}

                {props?.blogPostIds && <PostsByArrayOfIDs postIds={props?.blogPostIds} />}
            </Container>
        </Wrapper>
    );
}
